import * as React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Home from './pages/Home/Home';
import Search from './pages/Search/Search';
import DocumentView from './pages/DocumentView/DocumentView';


const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/search" render={((s) => <Search q={s.location.search} />)}/>
          <Route exact path="/documentView" render={((s) => <DocumentView q={s.location.search} />)} />
          {/* Not Found */}
          <Route component={() => <Redirect to="/" />} />
      </Switch>
      </BrowserRouter>
  );
};

export default Router;